import React from 'react';
import {
  LineChart,
  Line,
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
  Cell
} from 'recharts';
import { Card, CardContent, Typography, Box, Stack } from '@mui/material';

const GraficoFluxo = ({ dados, tipo = 'linha', periodo = '30dias' }) => {
  const formatarMoeda = (valor) => {
    return new Intl.NumberFormat('pt-BR', {
      style: 'currency',
      currency: 'BRL',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    }).format(valor);
  };

  const formatarDia = (data) => {
    if (periodo === '12meses') {
      const [ano, mes] = data.split('-');
      return `${mes}/${ano}`;
    }
    const date = new Date(data);
    return date.getDate();
  };

  const dadosFormatados = dados.map(item => ({
    ...item,
    dataFormatada: formatarDia(item.data || item.mes)
  }));

  return (
    <Card
      sx={{
        borderTop: '4px solid #ed3237',
        backgroundColor: '#f8f9fa',
        height: '100%'
      }}
    >
      <CardContent>
        <Typography variant="h6" sx={{ fontWeight: 'bold', mb: 2, color: '#3e4095' }}>
          {periodo === '30dias' ? 'Fluxo de Caixa - Últimos 30 Dias' : 'Fluxo de Caixa - Últimos 12 Meses'}
        </Typography>

        <ResponsiveContainer width="100%" height={300}>
          <LineChart data={dadosFormatados}>
            <CartesianGrid strokeDasharray="3 3" stroke="#e0e0e0" />
            <XAxis
              dataKey="dataFormatada"
              tick={{ fontSize: 12 }}
              stroke="#666"
            />
            <YAxis
              tick={{ fontSize: 12 }}
              stroke="#666"
              tickFormatter={(value) => `R$ ${(value / 1000).toFixed(0)}k`}
            />
            <Tooltip
              formatter={(value) => formatarMoeda(value)}
              contentStyle={{
                backgroundColor: '#fff',
                border: '1px solid #ccc',
                borderRadius: 4
              }}
            />
            <Legend
              wrapperStyle={{ paddingTop: '20px' }}
              iconType="line"
            />
            <Line
              type="monotone"
              dataKey="receita"
              stroke="#4caf50"
              strokeWidth={2}
              name="Receita"
              dot={{ fill: '#4caf50', r: 4 }}
            />
            <Line
              type="monotone"
              dataKey="despesa"
              stroke="#f44336"
              strokeWidth={2}
              name="Despesa"
              dot={{ fill: '#f44336', r: 4 }}
            />
            <Line
              type="monotone"
              dataKey="saldo"
              stroke="#2196f3"
              strokeWidth={2}
              name="Saldo"
              dot={{ fill: '#2196f3', r: 4 }}
              strokeDasharray="5 5"
            />
          </LineChart>
        </ResponsiveContainer>
      </CardContent>
    </Card>
  );
};

export default GraficoFluxo;
